export function normalizeSchemeProgrammeItem(row) {
  if (!row) return null

  const statusText = row.status ? '上架' : '下架'

  return {
    id: row.id || '',
    name: row.name || '',
    programmeType: row.programmeType || '',
    // table 列需要显示“方案类型”字符串
    type: row.programmeTypeLabel || row.programmeType || '',
    typeLabel: row.programmeTypeLabel || row.programmeType || '',
    // 真实字段 industry 可能是多选ID串（如 "1,2,3"），categoryLabel 仅单分类展示
    industry: row.industry || row.categoryLabel || '',
    categoryId: row.categoryId || '',
    categoryLabel: row.categoryLabel || '',

    // demo 结构里 scene/highlight 是用于卡片展示的文案字段
    scene: row.useCases || '',
    useCases: row.useCases || '',
    highlight: row.solutionTag || row.remark || '',
    remark: row.remark || '',

    // template 里直接对比 row.status === '上架'
    status: statusText,
    statusBool: !!row.status,
    statusLabel: statusText,
    workflowStatus: row.workflowStatus || '',
    workflowStatusLabel: row.workflowStatusLabel || '',
    headImgUrl: row.headImgUrl || '',
    linkMan: row.linkMan || '',
    mobilePhone: row.mobilePhone || '',
    resource: row.resource || '',
    url: row.url || '',
    creationDate: row.creationDate || '',

    // 最近被浏览：后端若返回则使用，否则兜底 0
    views: Number(row.views || 0),
    raw: row
  }
}

export function normalizeSchemeProgrammeDetail(model, files = []) {
  if (!model) return null

  return {
    id: model.id || '',
    name: model.name || '',
    type: model.programmeType || '',
    typeLabel: model.programmeTypeLabel || '',
    categoryId: model.categoryId || '',
    categoryLabel: model.categoryLabel || '',
    companyId: model.companyId != null ? String(model.companyId) : '',
    industry: model.categoryId || model.industry || '',
    remark: model.remark || '',
    useCases: model.useCases || '',
    solutionAdvantages: model.solutionAdvantages || '',
    solutionTag: model.solutionTag || '',
    headImgUrl: model.headImgUrl || '',
    linkMan: model.linkMan || '',
    mobilePhone: model.mobilePhone || '',
    explainUrl: model.explainUrl || '',
    resource: model.resource || '',
    status: !!model.status,
    programmeDate: model.programmeDate || '',
    files,
    raw: model
  }
}

export function normalizeSchemeProgrammeFile(file) {
  if (!file) return null

  return {
    id: file.id || '',
    designId: file.designId || '',
    fileName: file.fileName || '',
    filePath: file.filePath || '',
    fileProfile: file.fileProfile || '',
    fileSize: file.fileSize || 0,
    raw: file
  }
}
